import classNames from 'classnames';
import { TemplateClassNames } from '../../../../types/template-layouts';
import { LanguagesAbbr, Speaker } from '../../../../types/working-model';
import { getTextValue } from '../../../../utils/utils';
import { renderSocialLinks } from '../../../admin/create/homepage/editor/speakers/speaker';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
import { stylingOverrideReturns } from '../../utils';

interface SpeakerCardProps {
	speaker: Speaker;
	language: LanguagesAbbr;
	stylingOverrides: stylingOverrideReturns;
	template: TemplateClassNames;
	onClick: (speaker: Speaker) => void;
}
const SpeakerCard: React.FC<SpeakerCardProps> = ({
	speaker,
	language,
	stylingOverrides,
	template,
	onClick,
}) => {
	const {
		moduleTitleOverrides,
		moduleDescriptionOverrides,
		primaryButtonOverrides,
	} = stylingOverrides;
	const socialLinks = speaker.link_social ? renderSocialLinks(speaker.social_links || [], primaryButtonOverrides) : null;
	const { description } = getTextValue(speaker, language);
	return (
		<li className="speakers-column">
			<div className="speaker" onClick={() => onClick(speaker)}>
				<img src={speaker.image} alt={speaker.first_name} />
				<div className="speaker-name-container">
					<TypographyItem
						className={classNames('speaker-name', moduleTitleOverrides, {
							'evt-heading-3': template === TemplateClassNames.Apollo,
							'evt-heading-4': template !== TemplateClassNames.Apollo,
						})}
						tagName="h3"
					>
						{speaker.first_name} {speaker.last_name}
					</TypographyItem>
					<TypographyItem
						className={classNames('speaker-job-title', moduleTitleOverrides)}
						tagName="h5"
					>
						{speaker.job_title?.[language] ?? speaker.job_title?.base}
					</TypographyItem>
					<TypographyItem className={classNames('evt-body-text-2 speaker-about', moduleDescriptionOverrides)} tagName="p">
						{description}
					</TypographyItem>
					{socialLinks}
				</div>
			</div>
		</li>
	);
};

export default SpeakerCard;
